export interface Effectiveness {
  questionText: string;
  selfScore: number;
  selfScorePercentage: number;
  selfScoreText: string;
  otherScoreText: string;
  otherScore: number;
  otherScorePercentage: number;
  otherMinimum: number;
  otherMinimumPercentage: number;
  otherMaximum: number;
  otherMaximumPercentage: number;
}
